import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Webrez**
 *
 * @exports bs_254
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    function getTableValue(keyText) {
        const tableValue = [...document.querySelectorAll('td')].filter((el) => el.textContent?.includes(keyText) && el.nextElementSibling)[0]?.nextElementSibling;
        return tableValue?.textContent || '';
    }
    /**
       * @memberOf module:bs_254
       * @see {@link Price#onHashChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onHashChange = function onHashChange(ctx) {
        thn.pageCheck();
    };
    /**
       * @memberOf module:bs_254
       * @see {@link boot}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        const stepCalendar = document.querySelector('#Modal_0');
        if (stepCalendar) {
            const refreshPage = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(stepCalendar, refreshPage, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(stepCalendar, refreshPage);
            });
        }
        const container = document.querySelector('.panel-body');
        if (container) {
            const refresh = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(container, refresh, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.shutdown(() => {
                refresh.cancel();
                thn.stopObserveDom(container, refresh);
            });
        }
    };
    /**
       * @memberOf module:bs_254
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        // Hotel los Gatos does not allow to modify search in the BE
        if (thn.data.propertyId === 1016650) {
            return;
        }
        const container = document.querySelector('#right, #body_main');
        if (container && !thn.webRezObserver) {
            thn.webRezObserver = thn.debounce(function () {
                const loader = document.querySelector('#errorPanel');
                const loading = loader && thn.isVisible(loader);
                if (!loading) {
                    ctx.widget.refresh();
                }
            }, 1000);
        }
        thn.observeDom(container, thn.webRezObserver, {
            childList: true,
            subtree: true,
            attributes: false,
        });
        thn.pageUnload(() => {
            thn.stopObserveDom(container, thn.webRezObserver);
            delete thn.webRezObserver;
        });
    };
    /**
       * @memberOf module:bs_254
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        const widgetData = {};
        const $ = window.$;
        const webRez2 = window && window.aList;
        const webRez3 = window.location.pathname.match(/Bookings105/g);
        if (!$ || webRez2 || webRez3) {
            return widgetData;
        }
        // Dates
        widgetData.dateBegin = (thn.parseUrlParameter('date_from') || '').replace(/-/g, '/');
        widgetData.dateEnd = (thn.parseUrlParameter('date_to') || '').replace(/-/g, '/');
        // Guests, Adults & Children
        const adults = thn.parseUrlParameter('num_adults');
        const children = thn.parseUrlParameter('num_children');
        widgetData.adults = parseInt(adults, 10) || 2;
        widgetData.children = parseInt(children, 10) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // Prices & Currency || No Rooms
        const prices = $('.tableformrow:eq(0) tr').map((idx, ele) => {
            const $rate = $(ele).find('span.tableformtext');
            if (($rate).text().match(/Best Available Rate|Book Direct/)) {
                return thn.parseNumber($($rate).eq(1).text());
            }
            return undefined;
        }).toArray();
        const price = Math.min(...prices);
        const currency = thn.parseUrlParameter('exchange_rates');
        if (!price) {
            widgetData.noRooms = true;
        }
        else {
            widgetData.currency = currency;
            widgetData.price = price;
            widgetData.set = true;
        }
        return widgetData;
    };
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        const widgetData = {};
        const webRez3 = window.location.pathname.match(/Bookings105/g);
        // *** Dates ***
        const dates = window && window.aList;
        if (!dates || webRez3) {
            return widgetData;
        }
        if (dates && dates.length >= 1) {
            const dateBegin = ((dates[0]).oDate || {}).toDateString() || '';
            const dateEnd = ((dates[1]).oDate || {}).toDateString() || '';
            widgetData.dateBegin = translateDate(dateBegin, thn.data.language);
            widgetData.dateEnd = translateDate(dateEnd, thn.data.language);
        }
        // *** Guests, Adults ***
        // Prices does not vary with 1 or 2 adults, and max number of adults is 2
        // The Inn at Thorn Hill does not accept children under the age of 18 years
        widgetData.adults = 2;
        widgetData.guests = 2;
        widgetData.children = 0;
        // *** Prices & Currency || No Rooms ***
        const priceSelector = document.querySelectorAll('.rateValue2');
        const prices = [...priceSelector].map((elm) => {
            const priceEl = elm.childNodes || [];
            const price = (priceEl.length && priceEl[0] && priceEl[0].data);
            return price && thn.parseNumber(price);
        });
        const currency = thn.parseCurrency((document.querySelector('.rateValue2') || []).textContent);
        if (!prices) {
            widgetData.noRooms = true;
        }
        else if (prices && currency) {
            const price = prices.length && Math.min(...prices);
            widgetData.price = price;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        return widgetData;
    };
    // heathermountainlodge
    engine.priceParseData_v3 = function priceParseData_v3(ctx) {
        const widgetData = {};
        if (!window.location.pathname.match(/Bookings105/g)) {
            return widgetData;
        }
        // Dates
        const dateBegin = (document.querySelector('div.m-b-5:nth-child(2)')?.firstChild?.data || '');
        const dateEnd = (document.querySelector('div.m-b-5:nth-child(2)')?.lastChild?.data || '');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = translateDate(dateBegin, thn.data.language || 'en');
            widgetData.dateEnd = translateDate(dateEnd, thn.data.language || 'en');
        }
        // Guests, Adults & Children
        const adultsEl = document.querySelector('.invtype_room_result');
        const adults = adultsEl && adultsEl.getAttribute('num_adults');
        widgetData.adults = parseInt(adults, 10) || 2;
        widgetData.children = 0;
        widgetData.guests = widgetData.adults;
        // *** Prices & Currency || No Rooms ***
        const priceSelector = [...document.querySelectorAll('.rsItemRateValue')].filter((el) => {
            if (thn.data.accountUserId === 1042906) {
                return !el.parentElement?.nextElementSibling?.innerText?.match(/BC10|Non-Refundable Rate/i);
            }
            return el;
        });
        const prices = priceSelector.map((el) => thn.parseNumber(el?.textContent)).filter(Boolean);
        const auxCurrency = (document.querySelector('.rsItemValueWrap div:nth-child(2)') || {}).textContent;
        const price = prices && Math.min(...prices);
        const currency = auxCurrency && thn.parseCurrency(auxCurrency.split('/', 1)[0]);
        if (price && currency) {
            widgetData.price = price;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else if (thn.isVisible(document.querySelector('#hotel_room_search_noresult'))) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_254
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        const tableContainer = document.querySelector('#body_main tbody');
        const bookingDataObserver = thn.debounce(function () {
            ctx.widget.logger.debug('*************** DOM Changed **************');
            if (ctx.widget.setData().isSet() && getTableValue('Check-in')) {
                ctx.widget.save();
                thn.stopObserveDom(tableContainer, bookingDataObserver);
            }
        }, 600);
        thn.observeDom(tableContainer, bookingDataObserver);
        thn.pageUnload(function () {
            thn.stopObserveDom(tableContainer, bookingDataObserver);
        });
    };
    /**
       * @memberOf module:bs_254
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer;
        const purchase = thn.objectGet(dataLayer, 'purchase')?.actionField || window.purchase;
        let startDate = '';
        let endDate = '';
        const bookingId = thn.objectGet(dataLayer, 'transactionId', { first: false }) || thn.objectGet(dataLayer, 'transaction_id') || thn.objectGet(dataLayer, 'beConfirmationNumber', { first: false }) || thn.objectGet(dataLayer, 'id') || thn.objectGet(purchase, 'id') || document.querySelector('#wrapper > table.orrs_search_table1 > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(4) > tbody > tr:nth-child(4) > td > table > tbody >tr > td:nth-child(1)')?.textContent || document.querySelector('#body > div > div.wrClientContent > div > div > div > div:nth-child(4) > div > div > div > table > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(3) > tbody > tr:nth-child(4) > td > table > tbody > tr:nth-child(1) > td > table > tbody > tr > td:nth-child(3)')?.textContent;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        // Booking ID
        widgetData.bookingId = bookingId;
        // Dates
        if (!thn.data.propertyId === 1029519) {
            startDate = document.querySelector('#wrapper > table.orrs_search_table1 > tbody > tr > td > table > tbody > tr:nth-child(1) > td > table > tbody > tr:nth-child(3) > td:nth-child(1) > table > tbody > tr:nth-child(3) > td:nth-child(2)')?.textContent;
            endDate = document.querySelector('#wrapper > table.orrs_search_table1 > tbody > tr > td > table > tbody > tr:nth-child(1) > td > table > tbody > tr:nth-child(3) > td:nth-child(1) > table > tbody > tr:nth-child(3) > td:nth-child(2)')?.textContent;
        }
        const dateBeginDl = thn.objectGet(dataLayer, 'items', { first: false })?.[0]?.arrival || thn.objectGet(purchase, 'arrival') || thn.objectGet(dataLayer, 'beArrival', { first: false });
        const dateEndDl = thn.objectGet(dataLayer, 'items', { first: false })?.[0]?.departure || thn.objectGet(purchase, 'departure') || thn.objectGet(dataLayer, 'beDeparture', { first: false });
        const dateBeginDom = document.querySelector('#body > div > div.wrClientContent > div > div > div > div:nth-child(4) > div > div > div > table > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(3) > tbody > tr:nth-child(4) > td > table > tbody > tr:nth-child(4) > td > table > tbody > tr > td:nth-child(3)')?.textContent;
        const dateEndDom = document.querySelector('#body > div > div.wrClientContent > div > div > div > div:nth-child(4) > div > div > div > table > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(3) > tbody > tr:nth-child(4) > td > table > tbody > tr:nth-child(5) > td > table > tbody > tr > td:nth-child(3)')?.textContent;
        const dateBeginTable = getTableValue('Check-in');
        const dateEndTable = getTableValue('Check-out');
        thn.logger.debug(`check in date from table: ${dateBeginTable}`);
        thn.logger.debug(`check out from table: ${dateEndTable}`);
        const dateBegin = dateBeginDl?.replace(/-/g, '/') || translateDate(dateBeginTable, thn.data.language) || thn.dateToString(dateBeginDom) || translateDate(startDate, thn.data.language);
        const dateEnd = dateEndDl?.replace(/-/g, '/') || translateDate(dateEndTable, thn.data.language) || thn.dateToString(dateEndDom) || translateDate(endDate, thn.data.language);
        thn.logger.debug(`dateBegin: ${dateBegin}`);
        thn.logger.debug(`dateEnd: ${dateEnd}`);
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        // Price
        const price = thn.parseNumber(thn.objectGet(dataLayer, 'transactionTotal', { first: false }) || thn.objectGet(purchase, 'revenue') || thn.objectGet(dataLayer, 'value'));
        const taxPrice = thn.parseNumber(thn.objectGet(dataLayer, 'transactionTax', { first: false }) || thn.objectGet(purchase, 'tax') || thn.objectGet(dataLayer, 'tax'));
        const totalRawPrice = getTableValue('Total');
        const totalPrice = price + taxPrice;
        widgetData.price = totalPrice || thn.parseNumber(totalRawPrice) || (thn.parseNumber(document.querySelector('#wrapper > table.orrs_search_table1 > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(4) > tbody > tr:nth-child(6) > td > table > tbody > tr:nth-child(4) > td:nth-child(2)')?.textContent)) || (thn.parseNumber(document.querySelector('#body > div > div.wrClientContent > div > div > div > div:nth-child(4) > div > div > div > table > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(3) > tbody > tr:nth-child(6) > td > table > tbody > tr:nth-child(7) > td:nth-child(2)')?.textContent));
        const dataLayerItems = thn.objectGet(dataLayer, 'items', { first: false });
        // Guests
        const adultsTable = thn.parseNumber(getTableValue('Adults'));
        const childrenTable = thn.parseNumber(getTableValue('Children')) || 0;
        thn.logger.debug(`adults: ${adultsTable}`);
        thn.logger.debug(`children: ${childrenTable}`);
        if ((thn.data.visitor.lastComparison.adults === 0) && thn.empty(thn.data.visitorWebStorage.lastComparison)) {
            const totalGuests = dataLayerItems?.reduce((totals, booking) => {
                totals.adults += booking.adults;
                totals.children += (booking.children || 0);
                return totals;
            }, { adults: 0, children: 0 });
            widgetData.adults = totalGuests?.adults;
            widgetData.children = totalGuests?.children;
            if (!widgetData.adults) {
                widgetData.adults = adultsTable;
                widgetData.children = childrenTable;
            }
        }
        /* Currency : Even though there was a specific currency chosen when searching rooms, from the User Register page, the currency is back to default currency.
        So, we need to use the default currency for some properties. */
        let currency;
        const isUsDollarProperties = [1043381, 1035464, 1155345, 1155192].includes(thn.data.propertyId);
        const isCanadianDollarProperties = [1052476].includes(thn.data.propertyId);
        if (isUsDollarProperties) {
            currency = 'USD';
        }
        else if (isCanadianDollarProperties) {
            currency = 'CAD';
        }
        else {
            currency = thn.objectGet(dataLayer, 'currency', { first: false }) || document.querySelector('#body > div > div.wrClientContent > div > div > div > div:nth-child(4) > div > div > div > table > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table:nth-child(3) > tbody > tr:nth-child(5) > td > table > tbody > tr > td:nth-child(1) > div')?.textContent || 'CAD';
        }
        widgetData.currency = currency;
        return widgetData;
    };
    /**
       * @memberOf module:bs_254
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        return ctx.promocode;
    };
    return engine;
}

export { factory };
